module.exports = "https://r.nearpod.com/assets/media/image/back_icon-1148d959e683ec0204a5c9de32735407.svg";